import React, { Component } from 'react';
import { PlayStoreButton } from '../Button';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';
import ModalVideo from 'react-modal-video';
import BackgroundImage from '../../assets/img/grip_bg.png';
import { Trans } from "react-i18next";

const aboutRightBg = {
	background: "url(" + BackgroundImage + ") no-repeat center",
	backgroundSize: "cover"
}

class About extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		};
		this.openModal = this.openModal.bind(this);
	}

	openModal() {
		this.setState({ isOpen: true });
	}

	render() {
		return (
			<section className="about-area relative" id="about">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-7">
							<div className="about-left-content">
								<div className="section-title">
									<span className="lines" />
									<h2><Trans i18nKey="about.title" /></h2>
									<p><Trans i18nKey="about.desc" /></p>
								</div>
								<PlayStoreButton />
							</div>
						</div>
					</div>
					<div className="about-right-content" style={ aboutRightBg }>
						<div className="overlay overlay-bg" />
						<div className="video-popup align-items-center justify-content-center">
							<div>
								<button onClick={this.openModal} className="play-video video-play-button animate">
									<span />
								</button>
							</div>
							<p className="watch text-uppercase">Watch FishingGrip Video</p>
						</div>
					</div>

					<ModalVideo
						channel="youtube"
						isOpen={this.state.isOpen}
						videoId="eetKQStdgyI"
						onClose={() => this.setState({ isOpen: false })}
					/>
				</div>
			</section>
		);
	}
}

export default About;
